/**
 * Admin Light Theme — Component Tokens
 *
 * Frosted-white glass equivalents of the dark admin tokens. Same structural
 * shape, inverted luminance.
 */
import type { AdminComponentTheme } from '@/constants/shared/theme/types';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';

export const adminLightComponents: AdminComponentTheme = {
  sidebar: {
    bg: '#FFFFFF',
    border: 'rgba(0,0,0,0.08)',
    itemActiveBg: 'rgba(70,114,254,0.10)',
    itemHoverBg: 'rgba(0,0,0,0.03)',
    label: '#1A1A1A',
    description: '#777',
    indicator: PRIMITIVE_COLORS.resioBlue,
    headerGlow: [
      { color: 'rgba(71,115,254,0.20)', offset: 0 },
      { color: 'rgba(91,57,172,0.14)', offset: 0.4 },
      { color: 'rgba(171,52,112,0.10)', offset: 0.75 },
      { color: 'rgba(255,255,255,0)', offset: 1 },
    ],
    headerGlowHeight: 180,
  },
  header: {
    bg: 'transparent',
    border: 'rgba(0,0,0,0.06)',
    menuText: '#1A1A1A',
  },
  dataTable: {
    bg: 'rgba(255,255,255,0.82)',
    headerBg: 'rgba(245,245,247,0.9)',
    border: 'rgba(0,0,0,0.06)',
    row: 'transparent',
    rowAlt: 'rgba(0,0,0,0.02)',
    text: '#1A1A1A',
    filterBg: 'rgba(0,0,0,0.02)',
  },
  dataTableDensity: {
    compact: { cellPaddingY: 8, headerPaddingY: 10 },
    comfortable: { cellPaddingY: 14, headerPaddingY: 16 },
  },
  formInput: {
    bg: 'rgba(255,255,255,0.9)',
    border: 'rgba(0,0,0,0.08)',
    borderFocused: PRIMITIVE_COLORS.resioBlue,
    placeholder: '#999',
    text: '#1A1A1A',
    label: '#555',
  },
  selector: {
    bg: 'rgba(255,255,255,0.85)',
    border: 'rgba(0,0,0,0.08)',
    dropdownBg: '#FFFFFF',
    itemSelectedBg: 'rgba(70,114,254,0.08)',
    itemSelectedText: PRIMITIVE_COLORS.resioBlue,
  },
  dataCell: {
    text: '#1A1A1A',
    textMuted: '#777',
    textAccent: PRIMITIVE_COLORS.resioBlue,
  },
};
